import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../services';
import { AUTH_ROUTES } from '../tokens';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const storage = inject(StorageService);
  const routes = inject(AUTH_ROUTES);

  const isAuthenticated = storage.getItem('isLoggedIn') === 'true';
  console.log('[authGuard]', { isAuthenticated });
  if (!isAuthenticated) {
    console.log('[authGuard] → redirect to login');
    return router.parseUrl(routes.loginUrl);
  }

  console.log('[authGuard] → pass');
  return true;
};
